var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#47D5DC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#633001",
    fillRule: "evenodd",
    d: "M6.593 6.225C6.33 4.86 7.38 3.6 8.745 3.6c1.208 0 2.205.997 2.205 2.205v2.73c.315 0 .63-.053.945-.053.315 0 .578 0 .893.053v-2.73c0-1.208.997-2.205 2.205-2.205 1.365 0 2.415 1.26 2.205 2.625l-.578 3.202c2.048.893 3.623 2.468 3.623 4.41v1.208c0 1.627-1.05 2.993-2.573 3.885-1.522.945-3.517 1.47-5.775 1.47-2.257 0-4.252-.525-5.775-1.47-1.47-.892-2.52-2.258-2.52-3.885v-1.207c0-1.943 1.523-3.518 3.57-4.41l-.577-3.203Zm9.24 3.622.682-3.78c.158-.945-.525-1.837-1.522-1.837-.84 0-1.523.682-1.523 1.522v3.465c-.21-.052-.472-.052-.682-.052-.315 0-.578-.053-.893-.053-.315 0-.63 0-.945.053-.21 0-.472.052-.682.052V5.805c0-.84-.683-1.523-1.523-1.523-.945 0-1.68.893-1.47 1.838l.683 3.78c-2.205.84-3.675 2.31-3.675 3.99v1.207c0 2.573 3.412 4.673 7.612 4.673s7.613-2.1 7.613-4.672V13.89c.052-1.732-1.418-3.203-3.675-4.043Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDC90",
    d: "M19.56 15.045c0 2.572-3.412 4.673-7.612 4.673s-7.613-2.1-7.613-4.673v-1.207h15.278v1.207h-.053Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1884F",
    fillRule: "evenodd",
    d: "M7.275 6.12a1.517 1.517 0 0 1 1.47-1.838c.84 0 1.523.683 1.523 1.523V9.27a15.74 15.74 0 0 1 1.627-.105c.525 0 1.05.052 1.575.105V5.805c0-.84.682-1.523 1.522-1.523.945 0 1.68.893 1.523 1.838l-.683 3.78c2.206.84 3.728 2.31 3.728 3.99 0 2.572-3.412 4.672-7.612 4.672s-7.613-2.1-7.613-4.672c0-1.68 1.47-3.15 3.675-3.99l-.735-3.78Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#633001",
    d: "M9.795 13.523c0 .682-.368 1.26-.84 1.26-.473 0-.84-.578-.84-1.26 0-.683.367-1.26.84-1.26.472 0 .84.577.84 1.26Zm5.827 0c0 .682-.367 1.26-.84 1.26-.472 0-.84-.578-.84-1.26 0-.683.368-1.26.84-1.26.473 0 .84.577.84 1.26Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCake);
export default __webpack_public_path__ + "static/media/cake.6eee12b83bd9fbf2fb1eb5bf4093bfb6.svg";
export { ForwardRef as ReactComponent };